import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const SectionInnerWrapper = styled(Box)(({ theme }) => ({
  maxWidth: '1900px',
  margin: '0 auto',
  [theme.breakpoints.down('md')]: {
    padding: '0 20px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '0 16px',
  },
}));

export const StepsGridContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridAutoFlow: 'column',
  gridAutoColumns: '150px',
  alignItems: 'center',
  transform: 'scale(0.4)',
  overflowX: 'auto',
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  justifyContent: 'flex-start',
  scrollBehavior: 'smooth',
  WebkitOverflowScrolling: 'touch',

  '& > *': {
    minWidth: '150px',
  },

  '&::-webkit-scrollbar': {
    height: 8,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0,0,0,0.18)',
    borderRadius: 8,
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },

  [theme.breakpoints.up('sm')]: {
    gridAutoColumns: '160px',
    '& > *': {
      minWidth: '160px',
    },
  },

  [theme.breakpoints.up('md')]: {
    gridAutoColumns: '170px',
    transform: 'scale(1)',
    overflowX: 'visible',
    paddingLeft: 0,
    paddingRight: 0,
    justifyContent: 'center',
    '& > *': {
      minWidth: '170px',
    },
  },
}));

export const ButtonWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '77px',
  [theme.breakpoints.down('md')]: {
    marginTop: '50px',
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: '36px',
  },
}));
